<template>
  <v-container fluid mr-2 id="file-upload">
    <vue-dropzone 
      ref="dropzone" 
      id="dropzone" 
      v-on:vdropzone-error="uploadError" 
      v-on:vdropzone-success="fileUploaded" 
      v-on:vdropzone-file-added="fileAdded" 
      v-on:vdropzone-total-upload-progress="totalUploadProgress" 
      :destroyDropzone="destroyDropzone" 
      :options="dropzoneOptions">
    </vue-dropzone>
    <v-btn class="mt-2" @click="removeAllFiles">Tyhennä</v-btn>
    <v-btn class="mt-2" @click="pasteFile">Paste</v-btn>
  </v-container>
</template>

<script>
import { mapFields } from 'vuex-map-fields'
import firebase from 'firebase'

//console.log(navigator.clipboard)
        //navigator.clipboard.writeText("test")

export default {
    props: ['productId', 'productVariationId', 'companyId', 'orderedProductId', 'orderId', 'type','shopId'],
    data: () => ({
      destroyDropzone:true,
      mediaId:''
    }),
    mounted() {},
    created () {},
    computed: {
      dropzoneOptions(){
        // URL CANNOT BE SET TO LOCAL BECAUSE THE FILE CONVERTOR DOESNT WORK LOCALLY
        return {
          url: this.settings.isServer ? 'https://us-central1-avecor-709ff.cloudfunctions.net/uploadFile' : 'http://api-test.avecor.fi:5000/avecor-709ff/us-central1/uploadFile',
          //url:'https://us-central1-avecor-709ff.cloudfunctions.net/uploadFile',
          thumbnailWidth: 100,
          thumbnailHeight: 100,
          timeout:300000,
          autoProcessQueue:false,
          dictDefaultMessage:"Klikkaa ja valitse tai raahaa tiedosto tähän. MAX 2 KERRALLAAN."
        }
      },
      ...mapFields([
        'settings',
        'user',
      ]),
    },
    methods: {
      copy(){
        
        navigator.clipboard.writeText("test")
        .then(() => {
          console.log(`"${text}" was copied to your clipboard.`)
        })
        .catch(err => {
          console.error(`Error copying text to clipboard: ${err}`)
        })
      },
      async pasteFile(event){
        const clipboardItems = await navigator.clipboard.read();
        for (const clipboardItem of clipboardItems) {
          try {
            for (const type of clipboardItem.types) {
              console.log(type)
              if(type.includes("image")){
                const blob = await clipboardItem.getType(type);
                //console.log(URL.createObjectURL(blob));
                blob.name = 'myfilename.png'
                console.log(blob)
                this.$refs.dropzone.addFile(blob);
              }
              //
            }
          } catch (e) {
            console.error(e, e.message);
          }
        }
        
      },

      async fileAdded(file){
        var dropzone = this.$refs.dropzone
        var userId = this.user.uid
        var pieces = file.name.split(".")
        var filetype = pieces[pieces.length-1]
        //console.log(file)
        var errors = []
        if(this.type === "productImage") {
          /*if(filetype !== "png" && filetype !== "jpeg" && filetype !== "jpg"){
            errors.push("Tuotekuville on sallittu vain JPEG, JPG, PNG tiedostotyypit.")
          }*/
          if(file.width < 600){
            errors.push("Tuotekuvien on oltava vähintään 600 pikseliä leveitä.")
          }
          if(file.size > 10000000){
            errors.push("Tuotekuvien maksimi koko on 10mb.")
          }
        }
        if(this.type === "draft") {
          filetype = filetype.toLowerCase()
          if(filetype !== "png" && filetype !== "jpeg" && filetype !== "jpg" && filetype !== "pdf"){
            errors.push("Vedoksille on sallittu vain PDF, JPEG, JPG, PNG tiedostotyypit.")
          }
          if(file.size > 10000000){
            errors.push("Vedoksien maksimi koko on 10mb.")
          }
        }
        if(errors.length > 0 ){
          alert(errors.join())
          this.$refs.dropzone.removeFile(file)
          return
        }

        var t = this
        console.log(t.shopId)
        console.log("TYPE: "+t.type)
        firebase.auth().currentUser.getIdToken().then(function(token){
          dropzone.setOption('headers',
            {
                'Authorization':'Bearer '+token,
                'productId':t.productId !== undefined ? t.productId : '',
                'productVariationId':t.productVariationId !== undefined ? t.productVariationId : '',
                'shopId':t.shopId ? t.shopId : '',
                'companyId':t.companyId !== undefined ? t.companyId : '',
                'orderedProductId':t.orderedProductId !== undefined ? t.orderedProductId : '',
                'orderId':t.orderId !== undefined ? t.orderId : '',
                'type':t.type !== undefined ? t.type : '',
            })
          dropzone.processQueue()
        })
      },
      totalUploadProgress(uploadProgress, totalBytesm, totalByesSent ){
        if(uploadProgress==100){
          var el = document.getElementsByClassName("dz-progress")[0]
          el !== undefined ? el.className += " blink_me" : ""
        }
      },
      onFileChanged (event) {
        this.selectedFile = event.target.files[0]
      },
      async uploadError(file, message, xhr){
        console.log(message.error)
        alert(message.error)
      },
      removeAllFiles() {
        this.$refs.dropzone.removeAllFiles();
      },
      fileUploaded(){
        this.$refs.dropzone.removeAllFiles();
      },
    }
  }
</script>

<style>
.blink_me {
  animation: blinker 2s linear infinite;
}

@keyframes blinker {
  50% {
    opacity: 0;
  }
}
.dz-message {
  font-size:14px;
}
</style>


// WEBPACK FOOTER //
// src/components/blocks/MediaUpload.vue